import React, { useState, useEffect, useCallback } from 'react';
import PowerIcon from '../../../assets/img/dashboard/powerLarge';

const PlugType = ({ selectedItem, action, handlePower }) => {
    const [power, setPower] = useState(false);
    const [w, setW] = useState(0);
    const [mA, setMA] = useState(0);
    const [v, setV] = useState(0);

    useEffect(() => {
        const { power, curPower, curCurrent, curVoltage } = selectedItem.deviceState;
        
        setPower(power);
        setW(curPower / 10);
        setMA(curCurrent);
        setV(curVoltage / 10);
    }, [selectedItem.deviceState, selectedItem.deviceState.power, selectedItem.deviceState.curPower, selectedItem.deviceState.curVoltage]);
    
    const handlePlugPower = useCallback(() => {
        setPower(!power);
        handlePower(selectedItem);
        action();
    }, [action, handlePower, power, selectedItem]);
    
    return (
        <>
            <section className="device-setting-body">
                <div className="device-display plug">
                    <div className={power ? "display active" : "display"}>
                        <h2>{power ? w : '-'}</h2>
                        <p>소비 전력 (W)</p>
                    </div>
                    <section className="device-display-section">
                        <p>
                            <span className={`plug-current ${power ? "" : "deactive"}`}>{power ? `${mA} mA` : '-'}</span>
                            <span>전류 (mA)</span>
                        </p>
                        <p>
                            <span className={`plug-voltage ${power ? "" : "deactive"}`}>{power ? `${v}` : '-'}</span>
                            <span>전압 (V)</span>
                        </p>
                    </section>
                </div>
                <div className="device-control-wrap" />
            </section>
            <section className="device-setting-footer">
                <div className="device-button">
                    <button type="button" onClick={handlePlugPower}>
                        <PowerIcon /> 전원
                    </button>
                </div>
            </section>
        </>
    );
};

export default PlugType;
